import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export const PageHeader = ({ eyebrow, title, subtitle }) => (
  <section className="border-b border-slate-200 bg-white bg-grain">
    <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-16 py-14 sm:py-20 reveal">
      {eyebrow && <span className="text-xs font-semibold tracking-wider uppercase text-teal-800 bg-teal-50 px-3 py-1 rounded-full border border-teal-200">{eyebrow}</span>}
      <h1 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-serif text-slate-900 leading-tight">{title}</h1>
      {subtitle && <p className="mt-4 text-base sm:text-lg text-slate-600 max-w-2xl">{subtitle}</p>}
    </div>
  </section>
);
